import { useSelector } from 'react-redux';
import { SettingsState, Store } from '../store/types';
import { useMemo } from 'react';
import dayjs from 'dayjs';

export function FormattedDateComponent({
    date,
    suffix,
}: {
    date?: string;
    suffix?: string;
}) {
    const { formatDate } = useDateFormatter();
    return date ? formatDate(date, suffix) : '';
}

export function useDateFormatter() {
    const { i18n } = useSelector<Store, SettingsState>(state => state.settings);

    return useMemo(() => {
        dayjs.locale(i18n);

        const formatDate = (
            dateTime: string,
            suffix: string = '',
            withSeconds = false,
            withTime = true,
        ) => {
            const date = new Date(dateTime);

            return `${date.toLocaleString(i18n, {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: withTime ? '2-digit' : undefined,
                minute: withTime ? '2-digit' : undefined,
                second: withTime && withSeconds ? '2-digit' : undefined,
            })} ${suffix}`;
        };

        const formatChatDate = (dateTime: string) => {
            return dayjs(dateTime).format('dddd, DD. MMM');
        };

        return {
            formatDate,
            formatChatDate,
        };
    }, [i18n]);
}
